import type { ActionConfig } from "../ActionConfig";
import { NonDatabaseActionActionConfig } from "./NonDatabaseActionActionConfig";
import { Action, DatabaseAction, ExpandedAction } from "../../Action";
import { Dispatch, SetStateAction } from "react";
import { addOrDeleteItemInSet } from "../../../../utils/addOrDeleteItemInSet";
import { Match } from "../../../../requests/matches";
import { DetailedEvent } from "../../../../requests/matchEvents";

export class PossessionChangeActionConfig extends NonDatabaseActionActionConfig {
  constructor() {
    super(ExpandedAction.possessionChange);
  }

  getButtonPhrase = () => "Possession Change";

  isValid = (
    previousEvents: DetailedEvent[],
    pseudoEventActions: Set<ExpandedAction>
  ): boolean => {
    const mostRecentNonFlagEvent =
      this.getMostRecentNonFlagEvent(previousEvents);
    return (
      pseudoEventActions.has(ExpandedAction.override) ||
      (!!mostRecentNonFlagEvent &&
        [
          DatabaseAction.conversionGoalKick,
          DatabaseAction.conversionKickMiss,
          DatabaseAction.dropGoalKick,
          DatabaseAction.endOfHalf,
          DatabaseAction.ballGrounded,
          DatabaseAction.intoTouch,
          DatabaseAction.penaltyGoalKick,
        ].includes(mostRecentNonFlagEvent.action_type_id))
    );
  };
  doAction = async (
    _previousEvents: DetailedEvent[],
    _createEvent: (
      action: DatabaseAction,
      possessionTeamId: number,
      locX: number,
      locY: number
    ) => void,
    _pseudoEventActions: Set<ExpandedAction>,
    setPseudoEventActions: Dispatch<SetStateAction<Set<ExpandedAction>>>,
    _match: Match,
    _actionConfigs: Record<Action, ActionConfig>,
    _locX?: number,
    _locY?: number
  ): Promise<void> =>
    setPseudoEventActions((prevState) =>
      addOrDeleteItemInSet(prevState, ExpandedAction.possessionChange)
    );
}
